import { SharedContent } from './shared-content';
export const TransferToContent = {
  pageTitle: `Tell us where you'd like to transfer the investments`,
  continueButton: 'Continue',
  errorText: SharedContent.radioRequiredError,
  ira: {
    pageDescription: `You can open a <i>new</i> IRA with us, or you can move the money to an <i>eligible</i> IRA you already have open with us&#8212whichever you prefer.`,
    existingHeader: `Or select an eligible IRA`,
    newHeader: `Open a new IRA`,
  },
  newAccountLabel: `I prefer to open a new brokerage account`,

  nonretirement: {
    pageDescription: `You can open a <i>new</i> individual nonretirement account with us, or you can move the money to an <i>eligible</i> individual nonretirement account you already have open with us&#8212whichever you prefer.`,
    accordionItems: [
      {
        title: `Why don't I see my other accounts?`,
        content: `We can only transfer the money to an individual nonretirement account using this online process, so you'll only see those types of accounts listed here.`,
      },
      {
        title: `What is cost basis?`,
        content: `Cost basis is generally the cost you pay for your shares, including reinvested dividends and capital gains, as well as adjustments for transaction fees. It's an important calculation that's used to determine gains and losses on any shares you sell in a taxable (nonretirement) account.`,
        linkText: `Learn more about cost basis`,
      },
    ],
    existingHeader: `Or select an eligible individual nonretirement account`,
    newHeader: `Open a new individual nonretirement account`,
  },
  newAccountDescription: {
    header: `Next, you'll:`,
    bullets: [
      'Verify your personal information',
      'Confirm or update your address',
      'Answer some regulatory questions',
    ],
  },
};
